import React, { useEffect, useState } from 'react'
import { SafeAreaView, ScrollView } from 'react-native'
import tw from 'tailwind-rn'
import { useDispatch } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'

// import ActionCreators f rom '../../store/actions'

import { HGView, HGHeading } from '../../components/HGUI'
import { BlockGrid } from '../../components/Content'
import ActionCreators from '../../store/actions'
import { ResourceType } from '../../config/types'
import { RootStackParamList } from '../../navigators/AppNavigator'

type Props = {
  navigation: StackNavigationProp<RootStackParamList, 'Documentation'>
}

const InfoOverviewScreen = (props: Props) => {
  const { navigation } = props
  const [resource, setResource] = useState<ResourceType | null>(null)
  const dispatch = useDispatch()

  const loadInitOverviewResource = async () => {
    try {
      const result = await dispatch(
        ActionCreators.loadResource({ resourceId: '11' })
      )

      if (result?.title) {
        navigation.setOptions({ title: result.title })
      }

      setResource(result)
    } catch (e) {
      dispatch(ActionCreators.handleError(e))
    }
  }

  useEffect(() => {
    loadInitOverviewResource()
  }, [])

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ScrollView style={tw('px-3')}>
        <HGView>
          <HGHeading>Information</HGHeading>

          <BlockGrid blocks={resource?.blocks || null} />
        </HGView>
      </ScrollView>
    </SafeAreaView>
  )
}

export default InfoOverviewScreen
